import { Flex, Box, Text } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import UTMLink from "@components/UTMLink";
import { useMemo } from "react";

interface BlogCardProps {
  data: any;
}

const BlogCard = ({ data }: BlogCardProps) => {
  const postURL = useMemo(() => {
    return `/insights/resources/${data.slug}`;
  }, [data]);

  return (
    <UTMLink href={postURL} isExternal>
      <Flex
        p="12px 12px 40px"
        flexDir="column"
        gap="24px"
        bg="#1B443D"
        borderRadius="54px"
        color="#FFF"
        key={data.slug}
      >
        <Box
          h={{ base: "100%", lg: "197px" }}
          width="100%"
          borderRadius="44px 44px 22px 22px"
          overflow="hidden"
        >
          {data?.feature_image && (
            <BaseImage
              src={data.feature_image}
              alt={data.title}
              fill
              style={{ borderRadius: "44px 44px 22px 22px" }}
            />
          )}
        </Box>

        <Text
          fontWeight={600}
          fontSize="24px"
          noOfLines={2}
          lineHeight="26px"
          p="0 24px"
        >
          {data.title}
        </Text>
        <Text fontWeight={500} fontSize="14px" p="0 24px" opacity="0.7">
          {data.reading_time} mins read / updated on{" "}
          {new Date(data.updated_at).toDateString()}
        </Text>
      </Flex>
    </UTMLink>
  );
};

export default BlogCard;
